import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import "./Header.css";
import Stack from '@mui/material/Stack';
import Badge from '@mui/material/Badge';
import LogoutIcon from '@mui/icons-material/Logout';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import LanguageSwitcher from '../../i18n/LanguageSwitcher';
import { checkUser } from '../../api/admin/adminApi';
import MyInformation from '../Popup/Myinformation/Myinformation';
import Alert from '../Popup/Alert/Alert';
import { getPendingUsers } from '../../api/admin/userlist/user-list';
import { useProject } from "../../ProjectContext";
import LOGO from "../../Images/LOGO.png";
import Progress from '../Popup/Progress/Progress'; // ✅ Progress 컴포넌트 import (경로 맞게 수정)

const Header = () => {
  const { t } = useTranslation('utils');
  const navigate = useNavigate();
  const { logout } = useAuth();

  const [menuOpen, setMenuOpen] = useState(false);
  const [user, setUser] = useState(null);
  const [showMyInfo, setShowMyInfo] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [showProgress, setShowProgress] = useState(false); // ✅ 진행도 팝업 표시 상태
  const [pendingCount, setPendingCount] = useState(0);

  const menuRef = useRef(null);
  const { setUserInfo, projectInfo } = useProject(); // ✅ groupId, projectId, fileId 가져올 수 있음

  const { groupId, projectId, fileId } = projectInfo || {};

  // ✅ 승인 대기 유저 수 불러오기
  useEffect(() => {
    const fetchPendingCount = async () => {
      try {
        const users = await getPendingUsers();
        setPendingCount(users.length || 0);
      } catch (error) {
        console.error('🚨 승인 대기 유저 수 불러오기 실패:', error);
        setPendingCount(0);
      }
    };

    fetchPendingCount();
    const interval = setInterval(fetchPendingCount, 60000);
    return () => clearInterval(interval);
  }, []);

  // ✅ 사용자 정보 가져오기
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await checkUser();
        setUser(res.data);
        setUserInfo(res.data);
      } catch (err) {
        console.error("❌ 사용자 정보 불러오기 실패:", err);
      }
    };
    fetchUser();
  }, []);

  const handleLogout = async () => {
    try {
      const message = await logout();
      alert(message || '로그아웃 되었습니다.');
      navigate('/login', { replace: true });
    } catch (error) {
      console.error('[Header] 로그아웃 중 오류 발생:', error);
      alert('로그아웃 중 오류가 발생했습니다.');
    }
  };

  // ✅ 외부 클릭 시 메뉴 닫기
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const nameColor = 
  user?.roleName === "ROLE_ADMIN" || user?.roleName === "ROLE_SUPERUSER"
    ? "#9D91FF"
    : "#FFFFFF";


  return (
    <div className='Header_Container'>
      <img src={LOGO} alt="Logo Icon" className='Logo_img' />

      <div className='Header_info_Container'>
          {/* ✅ 진행도 확인 버튼 */}
          <div
          className='Progress_Button'
          style={{
            backgroundColor: "#9D91FF",
            color: "#fff",
            padding: "6px 12px",
            borderRadius: "6px",
            cursor: "pointer",
            marginLeft: "10px",
          }}
          onClick={() => setShowProgress(true)}
        >
           {t("progress.headertitle")}
        </div>
        <Stack spacing={4} direction="row">
          <Badge badgeContent={pendingCount} color="error">
            <NotificationsIcon
              style={{ cursor: 'pointer' }}
              onClick={() => setShowAlert((prev) => !prev)}
            />
          </Badge>
        </Stack>

        {showAlert && (
          <div className='Alert_Menu'>
            <Alert onCountChange={setPendingCount} />
          </div>
        )}

      

        {/* 사용자 메뉴 */}
        <div className='User_Box' ref={menuRef}>
          <div
            className='User_name'
            style={{ color: nameColor, cursor: "pointer" }}
            onClick={() => setMenuOpen(!menuOpen)}
          >
            {user ? user.name : "로딩중..."}
          </div>
          님

          {menuOpen && (
            <div className='User_Menu'>
              <div
                className='User_Menu_Item'
                onClick={() => {
                  setShowMyInfo((prev) => !prev);
                  setMenuOpen(false);
                }}
              >
                내 정보
              </div>
              <div className='User_Menu_Item'>환경설정</div>
              <LanguageSwitcher />
            </div>
          )}
        </div>

        <div className='Logoout_Box'>
          <LogoutIcon />
          <div onClick={handleLogout}>LogOut</div>
        </div>
      </div>

      {/* ✅ MyInformation 팝업 */}
      {showMyInfo && (
        <div className="PopupContainer">
          <MyInformation onClose={() => setShowMyInfo(false)} />
        </div>
      )}

      {/* ✅ Progress 팝업 */}
      {showProgress && (
        <div className="PopupContainer">
          <div
            style={{
              background: "#272934",
              padding: "20px",
              borderRadius: "8px",
              
              position: "relative",
            }}
          >
            <button
              style={{
                position: "absolute",
                top: "8px",
                right: "8px",
                border: "none",
                background: "transparent",
                fontSize: "18px",
                cursor: "pointer",
              }}
              onClick={() => setShowProgress(false)}
            >
              ✕
            </button>
            <Progress  />
          </div>
        </div>
      )}
    </div>
  );
};

export default Header;
